var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-item',{attrs:{"title":_vm.$t('settings.availability.defaultAvailabilityDisplay')}},[_c('availability-show-type-radio-field',{staticClass:"mt-0",attrs:{"name":_vm.name},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }